import { render } from "./UltraModal.vue?vue&type=template&id=40146f19&scoped=true"
import script from "./UltraModal.vue?vue&type=script&lang=js"
export * from "./UltraModal.vue?vue&type=script&lang=js"

import "./UltraModal.vue?vue&type=style&index=0&id=40146f19&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40146f19"]])

export default __exports__